import { db } from '../firebase';
import { collection, getDocs, doc, setDoc, getDoc, serverTimestamp } from 'firebase/firestore';

const BASE_URL = 'https://bpoconsultants.ph';

const MAIN_PAGES = [
  '',
  '/about',
  '/services',
  '/industries',
  '/resources',
  '/calculator',
  '/glossary',
  '/blog',
  '/training',
  '/contact',
  '/careers',
  '/privacy-policy',
  '/terms-of-service',
  '/cookie-policy',
  '/gdpr-compliance',
  '/training/ai-bd',
  '/training/experienced-bd',
  '/training/aspiring-bd',
  '/training/webinars'
];

const generateUrlTags = (urls) => {
  return urls.map(url => `
  <url>
    <loc>${BASE_URL}${url}</loc>
    <lastmod>${new Date().toISOString()}</lastmod>
    <changefreq>weekly</changefreq>
    <priority>${url === '' ? '1.0' : '0.8'}</priority>
  </url>`).join('');
};

export const generateSitemaps = async () => {
  try {
    const results = {};

    // 1. Main Pages Sitemap
    results.main = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
${generateUrlTags(MAIN_PAGES)}
</urlset>`;

    // 2. Blog Sitemap
    const postsSnap = await getDocs(collection(db, 'posts'));
    const blogUrls = postsSnap.docs.map(doc => {
      const data = doc.data();
      return `/blog/${data.slug || doc.id}`;
    });
    results.blog = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
${generateUrlTags(blogUrls)}
</urlset>`;

    // 3. Glossary Sitemap
    const glossarySnap = await getDocs(collection(db, 'glossary'));
    const glossaryUrls = glossarySnap.docs.map(doc => {
      const data = doc.data();
      return `/glossary/${data.slug || doc.id}`;
    });
    results.glossary = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
${generateUrlTags(glossaryUrls)}
</urlset>`;

    // 4. Resources Sitemap (Events & Webinars)
    const eventsSnap = await getDocs(collection(db, 'events'));
    const eventUrls = eventsSnap.docs.map(doc => `/training/webinars`);
    results.resources = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
${generateUrlTags([...new Set(eventUrls)])}
</urlset>`;

    // 5. Authors Sitemap
    const authorsSnap = await getDocs(collection(db, 'authors'));
    const authorUrls = authorsSnap.docs.map(doc => {
      const data = doc.data();
      return `/author/${data.slug || doc.id}`;
    });
    results.authors = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
${generateUrlTags(authorUrls)}
</urlset>`;

    // 6. Index Sitemap
    results.index = `<?xml version="1.0" encoding="UTF-8"?>
<sitemapindex xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
  <sitemap>
    <loc>${BASE_URL}/sitemap-main.xml</loc>
  </sitemap>
  <sitemap>
    <loc>${BASE_URL}/sitemap-blog.xml</loc>
  </sitemap>
  <sitemap>
    <loc>${BASE_URL}/sitemap-glossary.xml</loc>
  </sitemap>
  <sitemap>
    <loc>${BASE_URL}/sitemap-resources.xml</loc>
  </sitemap>
  <sitemap>
    <loc>${BASE_URL}/sitemap-authors.xml</loc>
  </sitemap>
</sitemapindex>`;

    // Save to Firestore
    await setDoc(doc(db, 'settings', 'sitemaps'), {
      ...results,
      lastGenerated: serverTimestamp(),
      status: 'success'
    }, { merge: true });

    return { success: true, results };
  } catch (error) {
    console.error("Sitemap generation failed:", error);
    return { success: false, error: error.message };
  }
};

export const triggerAutoUpdate = async () => {
  try {
    const settingsSnap = await getDoc(doc(db, 'settings', 'sitemaps'));
    const autoUpdate = settingsSnap.exists() ? settingsSnap.data().autoUpdate : true;

    if (autoUpdate !== false) {
      console.log("Auto-updating sitemaps...");
      await generateSitemaps();
    }
  } catch (error) {
    console.error("Auto-update check failed:", error);
  }
};
